import {
  HOROSCOPE_DETAIL_ARE_LOADING,
  HOROSCOPE_DETAIL_FETCH_DATA_SUCCESS,
  HOROSCOPE_DETAIL_HAVE_ERROR,
} from "../actionType";
import HttpService from "../../utils/httpService";
import { Get } from "../../services/api.service";

// Action creator function to handle different types of horoscope actions
export function HoroscopeDetailAction(action, payload) {
  switch (action) {
    case HOROSCOPE_DETAIL_HAVE_ERROR:
      return {
        type: action,
        hasError: payload,
      };

    case HOROSCOPE_DETAIL_ARE_LOADING:
      return {
        type: action,
        isLoading: payload,
      };

    case HOROSCOPE_DETAIL_FETCH_DATA_SUCCESS:
      return {
        type: action,
        horoscope: payload,
      };

    default:
      return;
  }
}

// Async action creator function to fetch horoscope data
export function horoscopeDetailFetchData(rashi, cat) {
  return (dispatch) => {
    try {
      // Dispatch action indicating data is loading
      dispatch(HoroscopeDetailAction(HOROSCOPE_DETAIL_ARE_LOADING, true));

      // Fetch horoscope data using GET request
      return new Promise((resolve, reject) => {
        const typePath = cat === "numerology" ? "" : "";
        Get(`${HttpService.horoscope}/${typePath}${rashi}?category=${cat}`).then(
          (result) => {
            // Dispatch action with fetched horoscope data
            dispatch(HoroscopeDetailAction(HOROSCOPE_DETAIL_FETCH_DATA_SUCCESS, result.data));
            resolve(result);
          },
          (error) => {
            // Dispatch error action when API call fails (including 404)
            dispatch(HoroscopeDetailAction(HOROSCOPE_DETAIL_HAVE_ERROR, true));
            dispatch(HoroscopeDetailAction(HOROSCOPE_DETAIL_ARE_LOADING, false));
            reject(error);
          },
        );
      });
    } catch (error) {
      // Dispatch action if there's an error in fetching data
      dispatch(HoroscopeDetailAction(HOROSCOPE_DETAIL_HAVE_ERROR, true));
      dispatch(HoroscopeDetailAction(HOROSCOPE_DETAIL_ARE_LOADING, false));
    }
  };
}
